import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Tooltip, Typography } from "@mui/material";
import NavigateButton from "../../../Components/UI/Buttons/NavigateButton.js";
import { useTranslation } from "react-i18next";
import BasicTable from "../../../Components/Table/Material/index.js";
import useApi from "../../../Hooks/useApi.js";
import { usePagination } from "../../../Hooks/usePagination.js";
import Modal from "../../../Components/Modal/index.js";
import SurveyCityListModal from "../../../Components/Modal/SurveyCityListModal.js";

import { useModal } from "../../../Hooks/useModal.js";
import { handleApiError } from "../../../Helpers/ErrorHandler.js";
import {
  SVG_DASHBOARD,
  SVG_CITY_LIST,
  SVG_DATA_SUBMISSION,
} from "../../../Assets/SVG/svg_util.js";
import Common from "../../../Components/Layouts/Common.js";
import ButtonToolbar from "../../Shared/ButtonToolbar.js";
import useWindowWidth from "../../../Hooks/useWindowWidth.js";

const ManageSurvey = () => {
  const { request, error } = useApi();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [surveyData, setsurveyData] = useState();
  const [selectedSurvey, setSelectedSurvey] = useState(null);
  const paginateProps = usePagination();
  const { isOpen, closeModal, openModal } = useModal();

  const fetchSurveyList = async () => {
    try {
      const response = await request(
        "GET",
        `/v1/survey/list?offset=${paginateProps.page}&limit=${paginateProps.rowsPerPage}`,
        {},
        "survey_service"
      );

      setsurveyData(
        response.content.map((el) => {
          return {
            ...el,
            assigned_cities: el.assignedCities,
            submitted_cities: el.submittedCities,
            assigned_date: el.startDate,
            end_date: el.endDate,
          };
        })
      );
      paginateProps.setTotalData(response.totalElements);
    } catch (error) {
      console.log(error);
      handleApiError(error);
    }
  };

  useEffect(() => {
    fetchSurveyList();
  }, [paginateProps.page, paginateProps.rowsPerPage]);

  const columns = [
    {
      id: "name",
      label: "Survey Title" || t("Survey.title"),
      minWidth: 170,
    },
    {
      id: "assigned_cities",
      label: "#Assigned Cities",
      minWidth: 100,
    },
    {
      id: "submitted_cities",
      label: "#Submitted Cities",
      minWidth: 100,
      align: "left",
    },
    {
      id: "assigned_date",
      label: "Assignment Date",
      minWidth: 100,
      align: "left",
      // renderCell: (row) => {
      //   return new Date(row.assigned_date)?.toLocaleDateString();
      // },
    },
    {
      label: "End Date",
      id: "end_date",
      minWidth: 100,
      align: "left",
      // renderCell: (row) => {
      //   return new Date(row.end_date)?.toLocaleDateString();
      // },
    },
    {
      id: "action",
      label: "Action",
      minWidth: 150,
      align: "center",
      renderCell: (row) => (
        <ActionButtonPanel
          row={row}
          handleCityList={(e) => {
            e.stopPropagation();
            setSelectedSurvey({
              surveyId: row.surveyId,
              surveyName: row.name,
            });
            openModal();
          }}
        />
      ),
    },
  ];

  const toggleFilterVisibility = () => {
    setIsFilterVisible(!isFilterVisible);
  };

  const windowWidth = useWindowWidth();

  return (
    <div className=" bg-white  relative h-full">
      <Common headline={"Manage Survey"}>
        <ButtonToolbar
          title={"Add New Survey"}
          navigateURL={"/create-survey"}
        />

        <BasicTable
          paginateProps={paginateProps}
          columns={columns}
          data={surveyData}
          maxHeight={15000}
        />

        <Modal
          isOpen={isOpen}
          onClose={closeModal}
          style={{ width: windowWidth >= 768 ? "70vw" : "90vw" }}
        >
          <SurveyCityListModal survey={selectedSurvey} />
        </Modal>
      </Common>
    </div>
  );
};

const ActionButtonPanel = ({ row, handleCityList }) => {
  return (
    <div className="inline-flex flex-col flex-wrap gap-2 justify-center text-xs">
      <Link
        to={"/view-survey-questionnaire"}
        state={{
          id: row.questionnaireId,
          viewType: "view",
        }}
      >
        <button
          className={`w-[130px] bg-[#1976d2] border border-gray-300  text-white rounded-md flex items-center justify-center p-1.5`}
        >
          View Mapped Questionnaire
        </button>
      </Link>

      <button
        onClick={handleCityList}
        className={`w-[130px] bg-[#1976d2] border border-gray-300  text-white rounded-md flex items-center justify-center p-1.5`}
      >
        City List
      </button>

      <Link
        to={"/survey-data-submission-city-list"}
        state={{
          surveyId: row.surveyId,
          surveyName: row.name,
          questionId: row.questionnaireId,
        }}
      >
        <button
          className={`w-[130px] bg-[#1976d2] border border-gray-300  text-white rounded-md flex items-center justify-center p-1.5`}
        >
          Data Submission
        </button>
      </Link>
    </div>
  );
};

export default ManageSurvey;
